import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 37,
  medium: 28,
  small: 19,
  xSmall: 15
};
const Forward10SecondsIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M26.0113 9.4468C23.4479 4.11958 17.5173 1.12455 11.5979 2.38275C4.57511 3.87549 0.0921015 10.7787 1.58485 17.8015C2.82528 23.6373 7.86189 27.8397 13.7396 28.0896L13.7821 27.0905L13.4816 27.0739C8.18655 26.7156 3.68679 22.8807 2.56299 17.5936C1.18508 11.111 5.32323 4.73882 11.8058 3.3609C17.2866 2.19591 22.7784 4.98157 25.1322 9.92642L20.7824 9.92672V10.9267H27.0108V4.69824L26.0108 4.69824L26.0113 9.4468Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4676 20.14C16.9676 20.14 17.3759 20.025 17.6926 19.795C18.0092 19.565 18.2559 19.2717 18.4326 18.915C18.6092 18.5584 18.7292 18.1667 18.7926 17.74C18.8559 17.3134 18.8876 16.9 18.8876 16.5C18.8876 16.1 18.8559 15.6867 18.7926 15.26C18.7292 14.8334 18.6092 14.4417 18.4326 14.085C18.2559 13.7284 18.0092 13.435 17.6926 13.205C17.3759 12.975 16.9676 12.86 16.4676 12.86C15.9676 12.86 15.5592 12.975 15.2426 13.205C14.9259 13.435 14.6792 13.7284 14.5026 14.085C14.3259 14.4417 14.2059 14.8334 14.1426 15.26C14.0792 15.6867 14.0476 16.1 14.0476 16.5C14.0476 16.9 14.0792 17.3134 14.1426 17.74C14.2059 18.1667 14.3259 18.5584 14.5026 18.915C14.6792 19.2717 14.9259 19.565 15.2426 19.795C15.5592 20.025 15.9676 20.14 16.4676 20.14ZM15.8426 18.975C16.0059 19.1184 16.2142 19.19 16.4676 19.19C16.7142 19.19 16.9209 19.1184 17.0876 18.975C17.2542 18.8317 17.3859 18.6384 17.4826 18.395C17.5792 18.1517 17.6476 17.8667 17.6876 17.54C17.7276 17.2134 17.7476 16.8667 17.7476 16.5C17.7476 16.1334 17.7276 15.7884 17.6876 15.465C17.6476 15.1417 17.5792 14.8567 17.4826 14.61C17.3859 14.3634 17.2542 14.1684 17.0876 14.025C16.9209 13.8817 16.7142 13.81 16.4676 13.81C16.2142 13.81 16.0059 13.8817 15.8426 14.025C15.6792 14.1684 15.5492 14.3634 15.4526 14.61C15.3559 14.8567 15.2876 15.1417 15.2476 15.465C15.2076 15.7884 15.1876 16.1334 15.1876 16.5C15.1876 16.8667 15.2076 17.2134 15.2476 17.54C15.2876 17.8667 15.3559 18.1517 15.4526 18.395C15.5492 18.6384 15.6792 18.8317 15.8426 18.975Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.6276 20V13H10.6976C10.6576 13.2134 10.5726 13.3934 10.4426 13.54C10.3126 13.6867 10.1559 13.8067 9.97257 13.9C9.78923 13.9934 9.58423 14.06 9.35757 14.1C9.1309 14.14 8.89757 14.16 8.65757 14.16V15.06H10.3776V20H11.6276Z",
        fill: "currentColor"
      }
    )
  );
};
Forward10SecondsIcon.iconName = "Forward10SecondsIcon";

export { Forward10SecondsIcon };
